import React from "react";
import { getVintedCategoryIcon } from "./helpers";

const VintedDetails = ({
  formData,
  vintedConnected,
  vintedMainCategories,
  vintedSubCategories,
  vintedCategoryHistory,
  vintedCurrentCategoryId,
  vintedSelectedCategoryPath,
  vintedLoadingCategories,
  handleVintedCategoryClick,
  handleVintedBack,
  resetVintedCategory,
  handleInputChange,
}) => {
  return (
    <div
      className="vinted-details-section mt-5 p-4"
      style={{
        border: "1px solid #ddd",
        borderRadius: "12px",
        background: "#f9f9f9",
      }}
    >
      <h4
        className="mb-3"
        style={{
          color: "#7B61FF",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "28px", marginRight: "10px" }}>👕</span>
        Vinted Listing Details
      </h4>

      <div className="form-group mb-4">
        <label
          style={{
            fontWeight: "600",
            display: "block",
            marginBottom: "10px",
          }}
        >
          Category Selection *
        </label>

        {!formData.vintedCategoryId ? (
          <div
            className="category-selection-container"
            style={{
              border: "2px solid #e0e0e0",
              borderRadius: "8px",
              padding: "15px",
              background: "white",
            }}
          >
            {vintedSelectedCategoryPath.length > 0 && (
              <div
                className="category-breadcrumb"
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "15px",
                  padding: "8px 12px",
                  background: "#f5f5f5",
                  borderRadius: "6px",
                }}
              >
                Categories:{" "}
                {vintedSelectedCategoryPath.map((cat, i) => (
                  <span key={i}>
                    {i > 0 && " › "}
                    <span
                      style={{
                        color: "#7B61FF",
                        fontWeight: 600,
                      }}
                    >
                      {cat}
                    </span>
                  </span>
                ))}
              </div>
            )}

            {vintedCategoryHistory.length > 0 && (
              <button
                className="btn btn-sm btn-light mb-3"
                onClick={handleVintedBack}
                style={{
                  padding: "8px 16px",
                  background: "#f0f0f0",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                }}
              >
                ← Back
              </button>
            )}

            {vintedLoadingCategories ? (
              <div style={{ textAlign: "center", padding: "30px" }}>
                <div
                  style={{
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #7B61FF",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 10px",
                  }}
                ></div>
                <div style={{ color: "#666" }}>Loading categories...</div>
              </div>
            ) : (
              <div
                className="categories-list"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                }}
              >
                {(vintedCurrentCategoryId === null
                  ? vintedMainCategories
                  : vintedSubCategories
                ).map((cat) => (
                  <div
                    key={cat.category_id}
                    className="category-item"
                    onClick={() => handleVintedCategoryClick(cat)}
                    style={{
                      padding: "12px 15px",
                      borderBottom: "1px solid #eee",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#f5f2ff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "white")
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          marginRight: "10px",
                          minWidth: "24px",
                        }}
                      >
                        {getVintedCategoryIcon(cat.name)}
                      </span>
                      <div>
                        <div style={{ fontWeight: 500 }}>{cat.name}</div>
                        {cat.is_final_selection && (
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#7B61FF",
                            }}
                          >
                            Click to select
                          </div>
                        )}
                      </div>
                    </div>
                    {!cat.is_final_selection && (
                      <span style={{ color: "#999" }}>→</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              background: "#E8F5E9",
              border: "2px solid #7B61FF",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "#2E7D32",
                marginBottom: "5px",
              }}
            >
              Selected: {formData.vintedCategoryPath.join(" > ")}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginBottom: "10px",
              }}
            >
              Category ID: {formData.vintedCategoryId}
            </div>
            <button
              className="btn btn-sm btn-link"
              style={{
                color: "#7B61FF",
                padding: 0,
                border: "none",
                background: "none",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={resetVintedCategory}
            >
              Change Category
            </button>
          </div>
        )}
      </div>

      <div className="form-group mb-4">
        <label
          style={{
            fontWeight: "600",
            display: "block",
            marginBottom: "10px",
          }}
        >
          Package Size *
        </label>
        <div
          className="package-size-container"
          style={{
            border: "2px solid #e0e0e0",
            borderRadius: "8px",
            padding: "15px",
            background: "white",
          }}
        >
          <div
            className={`package-option ${
              formData.vintedPackageSize === "small" ? "selected" : ""
            }`}
            onClick={() => handleInputChange("vintedPackageSize", "small")}
            style={{
              border:
                "2px solid " +
                (formData.vintedPackageSize === "small" ? "#7B61FF" : "#ddd"),
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "10px",
              cursor: "pointer",
              background:
                formData.vintedPackageSize === "small" ? "#F5F2FF" : "white",
            }}
          >
            <div
              style={{
                display: "inline-block",
                background: "#00D4AA",
                color: "white",
                padding: "4px 10px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: 600,
                marginBottom: "8px",
              }}
            >
              Recommended
            </div>
            <div
              style={{
                fontWeight: 600,
                fontSize: "16px",
                marginBottom: "5px",
              }}
            >
              Small
            </div>
            <div
              style={{
                color: "#666",
                fontSize: "14px",
                marginBottom: "5px",
              }}
            >
              For items that'd fit in a large envelope.
            </div>
          </div>
          <div
            className={`package-option ${
              formData.vintedPackageSize === "medium" ? "selected" : ""
            }`}
            onClick={() => handleInputChange("vintedPackageSize", "medium")}
            style={{
              border:
                "2px solid " +
                (formData.vintedPackageSize === "medium" ? "#7B61FF" : "#ddd"),
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "10px",
              cursor: "pointer",
              background:
                formData.vintedPackageSize === "medium" ? "#F5F2FF" : "white",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: "16px",
                marginBottom: "5px",
              }}
            >
              Medium
            </div>
            <div
              style={{
                color: "#666",
                fontSize: "14px",
                marginBottom: "5px",
              }}
            >
              For items that'd fit in a shoebox.
            </div>
          </div>
          <div
            className={`package-option ${
              formData.vintedPackageSize === "large" ? "selected" : ""
            }`}
            onClick={() => handleInputChange("vintedPackageSize", "large")}
            style={{
              border:
                "2px solid " +
                (formData.vintedPackageSize === "large" ? "#7B61FF" : "#ddd"),
              borderRadius: "8px",
              padding: "15px",
              cursor: "pointer",
              background:
                formData.vintedPackageSize === "large" ? "#F5F2FF" : "white",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: "16px",
                marginBottom: "5px",
              }}
            >
              Large
            </div>
            <div
              style={{
                color: "#666",
                fontSize: "14px",
              }}
            >
              For items that'd fit in a moving box.
            </div>
          </div>
        </div>
      </div>

      <div className="form-group mb-3">
        <label
          style={{
            fontWeight: "600",
            display: "block",
            marginBottom: "6px",
          }}
        >
          Product Size (Optional)
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="e.g., M, L, 8, 10"
          value={formData.vintedSize}
          onChange={(e) => handleInputChange("vintedSize", e.target.value)}
          style={{
            padding: "12px",
            borderRadius: "8px",
            border: "2px solid #ddd",
            width: "100%",
          }}
        />
      </div>

      <div
        className="mt-3 p-3"
        style={{
          borderRadius: "8px",
          backgroundColor: vintedConnected ? "#d4edda" : "#fff3cd",
          color: vintedConnected ? "#155724" : "#856404",
          border: `1px solid ${vintedConnected ? "#c3e6cb" : "#ffeeba"}`,
        }}
      >
        <strong>Vinted Extension Status:</strong>{" "}
        {vintedConnected
          ? "Connected - Ready to list!"
          : "Not connected - Click 'Integrate' button above"}
      </div>
    </div>
  );
};

export default VintedDetails;

